import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { url } from 'src/Helpers/utils/Constant';
import Toaster from 'src/Toaster/Toaster';
import dayjs, { Dayjs } from 'dayjs';
import { useAuthContext } from 'src/components/Context/AuthContext/AuthContext';
import { Helmet } from 'react-helmet-async';
import { LoadingButton } from '@mui/lab';
import {
  DesktopDatePicker,
  LocalizationProvider,
  TimePicker,
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CommonMultipleSelectMembers from 'src/common/CommonMultipleSelectMembers';
import SelectGroupMemberList from 'src/Types/module/invoice/group/SelectGroupMemberList';
import PostDataApis from 'src/common/FetchData/PostDataApis';

function CreateMeeting({ handleClose }) {
  const { user } = useAuthContext();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const { postData, loading, success } = PostDataApis(
    `${url}/api/member/meeting/create/for-admin`
  );
  const [meetingType, setMeetingType] = useState('');
  const Toast = Toaster();
  const [dateValue, setDateValue] = useState<Dayjs | null>(dayjs());
  const [timeValue, setTimeValue] = useState<Dayjs | null>(dayjs());
  const [membersId, setMembersId] = useState<number[]>([]);
  const [groupId, setGroupId] = useState<number[]>([]);

  const newTimeValue = timeValue.add(6, 'hour');

  useEffect(() => {
    if (success) {
      handleClose();
      reset();
    }
  }, [success]);
  const onSubmit = async (inputs: any) => {
    if (!meetingType) {
      Toast.fire({
        icon: 'error',
        title: `Please select meeting type`,
      });
      return;
    }
    if (dateValue && timeValue) {
      const bodyFormData = new FormData();

      for (const key in inputs) {
        if (inputs[key]) {
          if (typeof inputs[key] === 'object') {
            if (inputs[key][0]) bodyFormData.append(key, inputs[key][0]);
          } else {
            bodyFormData.append(key, inputs[key]);
          }
        }
      }

      bodyFormData.append(
        'member_meeting_time',
        newTimeValue.toISOString().slice(11, 19)
      );
      bodyFormData.append(
        'member_meeting_date',
        dateValue.toISOString().split('T')[0]
      );
      bodyFormData.append(
        'member_meeting_created_by',
        user.user_admin_id.toString()
      );

      if (meetingType) bodyFormData.append('member_meeting_type', meetingType);
      if (membersId && membersId?.length)
        bodyFormData.append('members_id', JSON.stringify(membersId));
      if (groupId && groupId?.length)
        bodyFormData.append('group_ids', JSON.stringify(groupId));

      await postData(bodyFormData);
    }
  };

  return (
    <>
      <Helmet>
        <title>Atab - Create meeting</title>
      </Helmet>

      <Box component='form' onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={{ xs: 2 }} mb={2}>
          <Grid xs={12} md={6} lg={6} item>
            <TextField
              fullWidth
              label='Member meeting title'
              required
              id='outlined-required'
              aria-invalid={errors.member_meeting_title ? 'true' : 'false'}
              helperText={
                errors.member_meeting_title?.type === 'required' &&
                'Meeting title is required'
              }
              type='text'
              {...register('member_meeting_title', { required: true })}
            />
          </Grid>
          <Grid xs={12} md={6} lg={6} item>
            <TextField
              fullWidth
              label='Member meeting place'
              required
              id='outlined-required'
              type='text'
              aria-invalid={errors.member_meeting_place ? 'true' : 'false'}
              helperText={
                errors.member_meeting_place?.type === 'required' &&
                'Meeting meeting is required'
              }
              {...register('member_meeting_place', { required: true })}
            />
          </Grid>
          <Grid xs={12} md={6} lg={6} item>
            <FormControl fullWidth>
              <InputLabel id='demo-simple-select-label'>
                Meeting type
              </InputLabel>
              <Select
                labelId='demo-simple-select-label'
                id='demo-simple-select'
                value={meetingType}
                // aria-invalid={errors.member_meeting_title ? "true" : "false"}
                label='Meeting type'
                onChange={(e) => setMeetingType(e.target.value)}
                required
              >
                <MenuItem value={'all'}>All</MenuItem>
                <MenuItem value={'specific'}>Specific</MenuItem>
                <MenuItem value={'group'}>Group</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {meetingType === 'specific' && (
            <Grid xs={12} md={12} lg={12} item>
              <CommonMultipleSelectMembers
                onChange={(e) => {
                  setMembersId(e);
                }}
                label='Select Members'
                size='medium'
              />
            </Grid>
          )}

          {meetingType === 'group' && (
            <Grid xs={12} md={12} lg={12} item>
              <SelectGroupMemberList
                onChange={(e) => {
                  setGroupId(e);
                }}
                label='Select Group List'
                size='medium'
              />
            </Grid>
          )}
          <Grid xs={12} md={6} lg={6} item>
            <TextField
              fullWidth
              id='outlined-required'
              type='file'
              label='Upload a meeting image'
              InputLabelProps={{
                shrink: true,
              }}
              {...register('member_meeting_img')}
            />
          </Grid>
          <Grid xs={12} md={6} lg={6} item>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DesktopDatePicker
                label='Meeting date'
                format='MM/DD/YYYY'
                value={dateValue}
                onChange={(e: any) => setDateValue(e)}
                sx={{ width: '100%' }}
                // renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
          </Grid>
          <Grid xs={12} md={6} lg={6} item>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <TimePicker
                label='Time'
                value={timeValue}
                onChange={(e) => setTimeValue(e)}
                sx={{ width: '100%' }}
                // renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
          </Grid>
          <Grid xs={12} md={6} lg={6} item>
            <TextField
              fullWidth
              label='Member meeting details'
              multiline
              rows={4}
              id='outlined-required'
              type='text'
              aria-invalid={errors.member_meeting_detail ? 'true' : 'false'}
              helperText={
                errors.member_meeting_detail?.type === 'required' &&
                'Meeting details is required'
              }
              {...register('member_meeting_details')}
            />
          </Grid>
        </Grid>
        {!loading ? (
          <Button type='submit' fullWidth variant='contained' disableElevation>
            Create Meeting
          </Button>
        ) : (
          <LoadingButton
            fullWidth
            loading
            loadingIndicator='Creating...'
            variant='contained'
            disabled
          >
            <span>Creating...</span>
          </LoadingButton>
        )}
      </Box>
    </>
  );
}

export default CreateMeeting;
